import { Star } from 'lucide-react'
import CommonModal from '../common/modal/CommonModal'

interface IChatRateExitModalProps {
  showRatingModal: boolean
  handleClose: () => void
  handleConfirmExit: () => void
  rating: number
  setRating: (rating: number) => void
  handleBottomBottonClick?: () => void
}
const ChatRateExitModal = ({
  handleClose,
  handleConfirmExit,
  rating,
  setRating,
  handleBottomBottonClick
}: IChatRateExitModalProps) => {
  return (
    <CommonModal
      onClose={handleClose}
      title='이번 상담은 어땠나요?'
      topButtonText='평가하기'
      bottomButtonText='평가 없이 넘어갈래요'
      topButtonOnClick={handleConfirmExit}
      bottomButtonOnClick={handleBottomBottonClick || handleClose}
      isTopButtonDisabled={rating === 0}
      modalContent={
        <div className='mb-6'>
          <div className='flex justify-center gap-2 mb-4'>
            {[1, 2, 3, 4, 5].map(star => (
              <button
                key={star}
                onClick={() => setRating(star)}
                className='transition-colors duration-200 hover:scale-110 transform'
              >
                <Star
                  size={32}
                  className={`${
                    star <= rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300 hover:text-yellow-200'
                  }`}
                />
              </button>
            ))}
          </div>
          <p className='text-center text-sm text-gray-600'>별점을 눌러서 상담을 평가해주세요</p>
        </div>
      }
    />
  )
}

export default ChatRateExitModal
